var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Belt"},[_c('Avatar',{attrs:{"avatar":_vm.avatar}}),(_vm.color)?_c('svgicon',{attrs:{"icon":"belt","color":_vm.color}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }